import type { CallStatus } from '../types';

const activeStatuses: CallStatus[] = ['reserved', 'connecting', 'active', 'reconnecting', 'ending'];

const statusLabels: Record<CallStatus, string> = {
  idle: 'جاهز للمكالمة',
  reserved: 'جارٍ حجز المكالمة',
  connecting: 'جارٍ الاتصال',
  active: 'المكالمة جارية',
  reconnecting: 'جارٍ استعادة الاتصال',
  ending: 'جارٍ الإنهاء',
  ended: 'انتهت المكالمة',
  failed: 'تعذرت المكالمة'
};

export function callDockPresentation(status: CallStatus, liveVoiceStatus: string | null): {
  active: boolean;
  canStart: boolean;
  label: string;
  tone: 'good' | 'warning' | 'bad' | 'neutral';
} {
  const active = activeStatuses.includes(status);
  if (active) {
    return { active, canStart: false, label: statusLabels[status], tone: status === 'active' ? 'good' : 'neutral' };
  }
  if (liveVoiceStatus === 'awaiting_credentials') {
    return { active, canStart: false, label: 'المكالمة الصوتية غير مفعّلة بعد — بانتظار بيانات اعتماد المزود', tone: 'warning' };
  }
  if (liveVoiceStatus !== 'configured_unverified') {
    return { active, canStart: false, label: 'المكالمة الصوتية غير متاحة حاليًا', tone: 'warning' };
  }
  return { active, canStart: true, label: statusLabels[status], tone: status === 'failed' ? 'bad' : 'neutral' };
}
